import { render } from "./BaseForm.vue?vue&type=template&id=af448ee0"
import script from "./BaseForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"source/js/vue/components/form/BaseForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "af448ee0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('af448ee0', __exports__)) {
    api.reload('af448ee0', __exports__)
  }
  
  module.hot.accept("./BaseForm.vue?vue&type=template&id=af448ee0", () => {
    api.rerender('af448ee0', render)
  })

}


export default __exports__